:host {
  /**
   * @prop --ch-tree-view-item-custom-padding-inline-start:
   * Specifies an additional value for the padding-inline-start of the items
   * without breaking the indentation of the items.
   * @default 0px
   */
  --ch-tree-view-item-custom-padding-inline-start: 0px;
  /**
   * @prop --ch-tree-view-item-gap:
   * Specifies the spacing between the images, checkbox, text and the
   * expandable button of the items.
   * @default 0px
   */
  --ch-tree-view-item-gap: 0px;
  /**
   * @prop --ch-tree-view-item__checkbox-size:
   * Specifies the checkbox size of the items.
   * @default 0.875em
   */
  --ch-tree-view-item__checkbox-size: 0.875em;
  /**
   * @prop --ch-tree-view-item__checkbox-size:
   * Specifies the expandable button size of the items.
   * @default 0.875em
   */
  --ch-tree-view-item__expandable-button-size: 0.875em;
  /**
   * @prop --ch-tree-view-item__image-size:
   * Specifies the box size that contains the start or end images of the items.
   * @default 0.875em
   */
  --ch-tree-view-item__image-size: 0.875em;
  /**
   * @prop --ch-tree-view-item__image-size:
   * Specifies the size of the start and end images of the items.
   * @default 100%
   */
  --ch-tree-view-item__background-image-size: 100%;
  /**
   * @prop --ch-tree-view-item__line--inset-inline-start:
   * Specifies an additional separation that only applies for the inline start
   * position of the item's line.
   * @default 0px
   */
  --ch-tree-view-item__line--inset-inline-start: 0px;
  /**
   * @prop --ch-tree-view-item__line--inset-inline-end:
   * Specifies the separation that only applies for the inline end position of
   * the item's line. This separation visually shows a gap between the line and
   * the item's header.
   * @default 0px
   */
  --ch-tree-view-item__line--inset-inline-end: 0px;
  --ch-tree-tab-size: calc(
    var(--ch-tree-view-item__image-size) +
      var(--ch-tree-view-item__expandable-button-size) +
      (var(--ch-tree-view-item-gap) * 2)
  );
  display: grid;
  grid-auto-rows: max-content;
  block-size: 100%;
  overflow: auto;
  contain: size;
}

.dragging-item ch-tree-view-item {
  pointer-events: var(--ch-tree-view-pointer-events, all);
}

.dragging-item .item-deny-drop {
  pointer-events: none;
}

.dragging-selected-items ch-tree-view-item[selected] {
  --ch-tree-view-pointer-events: none;
}

::part(item__header),
ch-tree-view-drop {
  --own-offset: 0px;
  --ch-tree-view-item-indentation: calc(
    var(--ch-tree-tab-size) * var(--level) - var(--own-offset) -
      var(--parent-offset, 0px) +
      var(--ch-tree-view-item-custom-padding-inline-start)
  );
}

::part(item__header level-0-leaf) {
  --ch-tree-view-item-indentation: calc(
    var(--ch-tree-view-item__expandable-button-size) +
      var(--ch-tree-view-item-gap) +
      var(--ch-tree-view-item-custom-padding-inline-start)
  );
}

::part(item__header expand-button),
ch-tree-view-drop {
  --own-offset: calc(
    var(--ch-tree-view-item__expandable-button-size) +
      var(--ch-tree-view-item-gap)
  );
}

::part(item__header even-level),
ch-tree-view-drop.gx-even-level {
  --parent-offset: var(--parent-offset-odd);
}

::part(item__header odd-level),
ch-tree-view-drop.gx-odd-level {
  --parent-offset: var(--parent-offset-even);
}

ch-tree-view-drop {
  margin-inline-start: var(--ch-tree-view-item-indentation);
}

::part(item__header) {
  padding-inline-start: var(--ch-tree-view-item-indentation);
}

::part(item__group even-level) {
  --parent-offset-even: calc(
    var(--ch-tree-view-item__expandable-button-size) +
      var(--ch-tree-view-item-gap) + var(--parent-offset-odd, 0px)
  );
}

::part(item__group odd-level) {
  --parent-offset-odd: calc(
    var(--ch-tree-view-item__expandable-button-size) +
      var(--ch-tree-view-item-gap) + var(--parent-offset-even, 0px)
  );
}

ch-tree-view-item > ch-tree-view-drop:first-child {
  transform: translateY(0);
}
ch-tree-view-item > ch-tree-view-drop:first-child::after {
  inset-block-start: 0px;
}
ch-tree-view-item > ch-tree-view-drop:last-child {
  transform: translateY(calc(var(--ch-tree-view-drop--size) * -1));
}
ch-tree-view-item > ch-tree-view-drop:last-child::after {
  inset-block-start: calc(var(--ch-tree-view-drop--size) * 0.5);
}